var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabBox"},[_vm._l((_vm.tabData),function(item,index){return [_c('div',{key:index,staticClass:"tabItem",class:item.checked ? 'actived':'',on:{"click":function($event){return _vm.itemClick(item)}}},[_c('span',[_vm._v(_vm._s(item.name))]),_c('i',[_vm._v(_vm._s(item.totalMoney.toFixed(2))+"元")])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }